import { render, staticRenderFns } from "./add_internship_modal.vue?vue&type=template&id=20aad9db&scoped=true"
import script from "./add_internship_modal.vue?vue&type=script&lang=js"
export * from "./add_internship_modal.vue?vue&type=script&lang=js"
import style0 from "./add_internship_modal.vue?vue&type=style&index=0&id=20aad9db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20aad9db",
  null
  
)

export default component.exports